<template>
    <resource-index title="Счета" endpoint="admin/assets/accounts">
        <template slot="header-buttons">
            <router-link
                class="btn btn-secondary"
                :to="{
                    name: 'admin.assets.accounts.create',
                }">Создать</router-link>
        </template>

        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Название</th>
                <th class="text-left p-3 px-5" scope="col">Банк</th>
                <th class="text-left p-3 px-5" scope="col">Баланс</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps">
            <tr class="border-b bg-gray-100">
                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.name" />
                </th>

                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.bank" />
                </th>

                <th class="p-3 px-5" scope="col"></th>

                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                {{ slotProps.entry.name }}
            </td>

            <td class="p-3 px-5">
                {{ slotProps.entry.bank }}
            </td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success">
                    {{ slotProps.entry.balance }} ₽
                </span>
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.assets.accounts.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info">Изменить</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
    import ResourceIndex from '@/components/Resource/ResourceIndex';
    
    export default {
        components: {
            ResourceIndex,
        },
    }
</script>